import React from "react";
import {Box, Chip, MenuItem, TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {deliveryProgress} from "./delivery-progress";

export const deliveryStatuses = ["ASSIGNED", "ACCEPTED", "PICKED_UP", "IN_DELIVERY", "DELIVERED", "CANCELLED"];
export const deliveryStatusLabel = status => status === "CANCELLED" ? "Cancelled" : deliveryProgress(status).label;

export default function CourierDeliveryFilters({courier, status, onStatusChange, onClearCourier}) {
    const {t} = useTranslation();
    return <Box sx={{display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap", mb: 2}}>
        <TextField select size="small" label={t("CourierDeliveryProgressTitle")} value={status}
            slotProps={{select: {displayEmpty: true}, inputLabel: {shrink: true}}}
            onChange={event => onStatusChange(event.target.value)} sx={{minWidth: 200}}>
            <MenuItem value="">{t("AllStatuses")}</MenuItem>
            {deliveryStatuses.map(value => <MenuItem value={value} key={value}>{t(deliveryStatusLabel(value))}</MenuItem>)}
        </TextField>
        <Chip label={courier ? courier.name : t("CourierDashboardAllCouriers")}
            onDelete={courier ? onClearCourier : undefined}/>
        <Typography variant="caption" color="text.secondary">{t("CourierDashboardRefreshHint")}</Typography>
    </Box>;
}
